import { Badge as MuiBadge, BoxProps as MuiBadgeProps } from '@mui/material';

export const Badge = MuiBadge;
export type BadgeProps = MuiBadgeProps;
